<div class="admin-dashboard">
  <mat-toolbar color="primary" class="admin-toolbar">
    <button mat-icon-button (click)="drawer.toggle()">
      <mat-icon>menu</mat-icon>
    </button>
    <span>Lenali - Administration</span>
    <span class="toolbar-spacer"></span>
    <button mat-icon-button (click)="logout()">
      <mat-icon>exit_to_app</mat-icon>
    </button>
  </mat-toolbar>

  <mat-drawer-container class="admin-container">
    <mat-drawer #drawer mode="side" opened>
      <mat-nav-list>
        <a mat-list-item routerLink="/admin/dashboard" routerLinkActive="active">
          <mat-icon matListItemIcon>dashboard</mat-icon>
          <span matListItemTitle>Tableau de bord</span>
        </a>
        <a mat-list-item routerLink="/admin/account-deletion-requests" routerLinkActive="active">
          <mat-icon matListItemIcon>delete_forever</mat-icon>
          <span matListItemTitle>Demandes de suppression</span>
        </a>
        <mat-divider></mat-divider>
        <a mat-list-item routerLink="/" target="_blank">
          <mat-icon matListItemIcon>public</mat-icon>
          <span matListItemTitle>Voir le site</span>
        </a>
      </mat-nav-list>
    </mat-drawer>

    <mat-drawer-content>
      <div class="content">
        <h1>Tableau de bord</h1>

        <div *ngIf="loading" class="loading-container">
          <mat-spinner diameter="40"></mat-spinner>
        </div>

        <div *ngIf="!loading" class="dashboard-content">
          <div class="stats-cards">
            <ng-container *ngIf="stats$ | async as stats">
              <mat-card class="stats-card pending">
                <mat-card-content>
                  <div class="stat-value">{{ stats.pending }}</div>
                  <div class="stat-label">En attente</div>
                </mat-card-content>
              </mat-card>
              
              <mat-card class="stats-card processing">
                <mat-card-content>
                  <div class="stat-value">{{ stats.processing }}</div>
                  <div class="stat-label">En cours</div>
                </mat-card-content>
              </mat-card>
              
              <mat-card class="stats-card completed">
                <mat-card-content>
                  <div class="stat-value">{{ stats.completed }}</div>
                  <div class="stat-label">Complétées</div>
                </mat-card-content>
              </mat-card>
              
              <mat-card class="stats-card rejected">
                <mat-card-content>
                  <div class="stat-value">{{ stats.rejected }}</div>
                  <div class="stat-label">Rejetées</div>
                </mat-card-content>
              </mat-card>
              
              <mat-card class="stats-card total">
                <mat-card-content>
                  <div class="stat-value">{{ stats.total }}</div>
                  <div class="stat-label">Total</div>
                </mat-card-content>
              </mat-card>
            </ng-container>
          </div>
          
          <div class="action-buttons">
            <button mat-raised-button color="primary" (click)="navigateToDeletionRequests()">
              <mat-icon>format_list_bulleted</mat-icon>
              Gérer les demandes de suppression
            </button>
          </div>
        </div>
      </div>
    </mat-drawer-content>
  </mat-drawer-container>
</div>
